import { BASE_URL_API } from '@constants/base';
import { get, post } from '@utils/ajax';

/**
 * Staff Management Service
 * Handles all staff management related API calls
 */
const staffManagementService = (() => {
    // Get staff management list
    const getStaffManagementList = async params => {
        try {
            const response = await get(`${BASE_URL_API}/main/staffManagement/list_api.php`, params, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    // Insert staff
    const insertStaff = async payload => {
        try {
            const response = await post(`${BASE_URL_API}/main/staffManagement/insert_api.php`, payload, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    // Delete staff
    const deleteStaff = async payload => {
        try {
            const response = await post(`${BASE_URL_API}/main/staffManagement/delete_api.php`, payload, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    // Update staff
    const editStaff = async payload => {
        try {
            const response = await post(`${BASE_URL_API}/main/staffManagement/edit_api.php`, payload, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    // get staff info edit
    const getStaffInfoEdit = async payload => {
        try {
            const response = await get(
                `${BASE_URL_API}/main/staffManagement/edit_api.php`,
                {
                    ...payload,
                    method: 'info'
                },
                {
                    showError: true
                }
            );
            return response;
        } catch (error) {
            return error;
        }
    };

    return {
        getStaffManagementList,
        insertStaff,
        deleteStaff,
        editStaff,
        getStaffInfoEdit
    };
})();

export default staffManagementService;
